import BasePage from "@/infrastructure/BasePage/basePage.component";
import React from "react";
import { useTranslation } from "react-i18next";

type PageLeadsProps = {
  // TODO: add props here
};

const PageLeads: React.FC<PageLeadsProps> = (props) => {
  const { t } = useTranslation();
  return (
    <BasePage currPage="leads">
      <div className="h-full overflow-y-auto">
        <h1 className="mt-2 mb-3 text-center text-3xl font-bold">
          {t("Pricing & Lead Time Estimation")}
        </h1>
      </div>
    </BasePage>
  );
};

export default PageLeads;
